import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { LeafIcon } from 'lucide-react';
export function SustainabilitySection() {
  return <section id="sustainability" className="bg-gradient-to-b from-sageDark to-sageLight py-32 px-6 md:px-12 text-center relative" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <ScrollReveal data-id="element-153">
          <div className="w-full h-px bg-gold/30 mb-16" data-id="element-154"></div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-155">
          <div className="flex justify-center mb-10" data-id="element-156">
            <div className="w-32 h-32 rounded-full border-2 border-gold flex items-center justify-center bg-white/5 backdrop-blur-sm" data-id="element-157">
              <LeafIcon className="w-16 h-16 text-white" strokeWidth={1} data-id="element-158" />
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-159">
          <h2 className="text-5xl md:text-7xl font-semibold text-white mb-10" data-id="element-160">
            Certified Organic
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.6} data-id="element-161">
          <p className="text-xl md:text-2xl text-white/90 font-light leading-relaxed mb-16" data-id="element-162">
            Glenlofty Estate is certified organic and a proud member of
            Sustainability Winegrowing Australia (SWA). Organic certification
            ensures healthier soils, stronger vines, and increased biodiversity,
            resulting in wines that truly reflect their place.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.8} data-id="element-163">
          <div className="w-full h-px bg-gold/30" data-id="element-164"></div>
        </ScrollReveal>
      </div>
    </section>;
}